import * as React from "react";
import {
  Button as ShadcnButton,
  type ButtonProps as ShadcnButtonProps,
} from "@/components/ui/button";

interface Props extends Omit<ShadcnButtonProps, "variant" | "size"> {
  text?: string;
  loading?: boolean;
  variant?: ShadcnButtonProps["variant"];
  size?: ShadcnButtonProps["size"];
  to?: ShadcnButtonProps["to"];
}

const Button = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, Props>(
  ({ loading = false, text, children, variant, size, to, ...rest }, ref) => {
    return (
      <ShadcnButton
        ref={ref}
        variant={variant}
        size={size}
        loading={loading}
        text={text}
        to={to}
        {...rest}
      >
        {children}
      </ShadcnButton>
    );
  },
);

Button.displayName = "Button";

export default Button;
